export default function isTruthy(val) {
    return val !== undefined && val !== null && val !== "";
}
